import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { dashboardCardSx } from "../constants";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function AlertDialog({ row, onClose }) {
  return (
    <Dialog
      open={Boolean(row)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          ...dashboardCardSx,
          color: "#fff",
        },
      }}
    >
      <DialogTitle>
        <MDBox display="flex" alignItems="center" justifyContent="space-between">
          <MDBox>
            <MDTypography variant="h6" color="white" fontWeight="bold">
              Generated Alert
            </MDTypography>
            <MDTypography variant="caption" color="white">
              {row?.name || "Device"}
            </MDTypography>
          </MDBox>
          <IconButton onClick={onClose} size="small" sx={{ color: "#fff" }}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <MDBox p={1.5} borderRadius="md" sx={{ backgroundColor: "rgba(251, 140, 0, 0.16)", border: "1px solid rgba(251, 140, 0, 0.45)" }}>
            <MDTypography variant="button" color="white" fontWeight="bold">
              {row?.alertType && row.alertType !== "-" ? row.alertType : "Alert"}
            </MDTypography>
            <MDTypography variant="body2" color="white" mt={0.5}>
              {row?.alert || "No alert description available."}
            </MDTypography>
          </MDBox>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", sm: "140px 1fr" }} gap={1}>
            <MDTypography variant="caption" color="white" fontWeight="bold">
              Generated
            </MDTypography>
            <MDTypography variant="caption" color="white">
              {row?.alertAge || "-"}
            </MDTypography>
            <MDTypography variant="caption" color="white" fontWeight="bold">
              Location
            </MDTypography>
            <MDTypography variant="caption" color="white">
              {row?.location || "-"}
            </MDTypography>
            <MDTypography variant="caption" color="white" fontWeight="bold">
              Entity
            </MDTypography>
            <MDTypography variant="caption" color="white">
              {row?.entityName || "-"}
            </MDTypography>
            <MDTypography variant="caption" color="white" fontWeight="bold">
              Identifier
            </MDTypography>
            <MDTypography variant="caption" color="white">
              {row?.identifier || "-"}
            </MDTypography>
          </MDBox>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AlertDialog;